<script setup lang="ts">
import type { Components } from '@/api/generated/api';
import type { IRequiredActionPrompt } from '@/composables/requiredAction/requiredAction.types';
import SelectedCompetenceRow from '@/core/competences/SelectedCompetenceRow.vue';
import RequiredActionTarget from '@/core/elements/RequiredActionTarget.vue';
import PerformanceLevelRatingInput from '@/core/performance-visuals/PerformanceLevelRatingInput.vue';
import type { ISelectedCompetence } from '@/interfaces';

const emit = defineEmits<{
  'update:value': [value: number | null];
  'interact:rating': [];
  remove: [];
}>();

const props = withDefaults(
  defineProps<{
    assessment?: Components.Schemas.CompetenceAssessmentDto;
    disabled?: boolean;
    removable?: boolean;
    ratingPrompt?: IRequiredActionPrompt | null;
    selectedCompetence: ISelectedCompetence;
    value: number | null;
  }>(),
  {
    assessment: undefined,
    disabled: false,
    ratingPrompt: null,
    removable: true,
  },
);
</script>

<template>
  <SelectedCompetenceRow
    :disabled="props.disabled"
    :removable="props.removable"
    :selected-competence="props.selectedCompetence"
    @remove="emit('remove')"
  >
    <template v-if="props.assessment" #trailing>
      <RequiredActionTarget :prompt="props.ratingPrompt" @dismiss="emit('interact:rating')">
        <template #default="{ targetClass, describedBy }">
          <PerformanceLevelRatingInput
            :class="targetClass"
            :aria-describedby="describedBy"
            :accessible-label="props.selectedCompetence.competence.description"
            :disabled="props.disabled"
            :model-value="props.value"
            :performance-visual="props.assessment.performanceVisual"
            @update:model-value="emit('update:value', $event)"
          />
        </template>
      </RequiredActionTarget>
    </template>
  </SelectedCompetenceRow>
</template>
